
import { MapLocation } from '@/types/location';

// Star Zone Billiards Center Locations
export const starZoneBilliardsCenters: MapLocation[] = [
  {
    id: 48001,
    name: "Star Zone Billiards - Riyadh (Al Morsalat)",
    type: "Game Center",
    devices: 4,
    coordinates: [24.754922195073988, 46.67946345028184],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
